module.exports = __webpack_public_path__ + "img/warn.20012a83.png";